import parlamentarPhoto from '@/assets/parlamentar-photo.jpg';

interface ParliamentarianHeaderProps {
  name: string;
  position: string;
  party: string;
  reportTitle: string;
  photoUrl?: string;
}

export function ParliamentarianHeader({ name, position, party, reportTitle, photoUrl }: ParliamentarianHeaderProps) {
  return (
    <header className="bg-card rounded-xl shadow-elevated p-6 mb-8">
      <div className="flex flex-col md:flex-row items-center md:items-start md:space-x-6 space-y-4 md:space-y-0">
        <img
          src={photoUrl || parlamentarPhoto}
          alt={`Foto de ${name}`}
          className="w-32 h-32 rounded-full border-4 border-accent object-cover"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = "https://via.placeholder.com/128x128/e5e7eb/6b7280?text=Foto";
          }}
        />
        <div className="text-center md:text-left flex-1">
          <h1 className="text-3xl font-bold text-foreground mb-2 font-inter">
            {name}
          </h1>
          <p className="text-lg text-accent font-medium mb-3">
            {position} • {party}
          </p>
          <h2 className="text-xl font-semibold text-muted-foreground">
            {reportTitle}
          </h2>
        </div>
      </div>
    </header>
  );
}